module.exports = __webpack_public_path__ + "media/images/gift/gift-campaign-bg-966ef2ca9899568bf3c52d8bc4901534.png";